import { render, staticRenderFns } from "./NotificationsSetting.vue?vue&type=template&id=2bca7831&"
import script from "./NotificationsSetting.vue?vue&type=script&lang=js&"
export * from "./NotificationsSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_Lavoro\\ALCYON\\Homestead\\code\\reporting\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bca7831')) {
      api.createRecord('2bca7831', component.options)
    } else {
      api.reload('2bca7831', component.options)
    }
    module.hot.accept("./NotificationsSetting.vue?vue&type=template&id=2bca7831&", function () {
      api.rerender('2bca7831', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/settings/NotificationsSetting.vue"
export default component.exports